// PartnerBrandsSection.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import '../StylesComponents/partner-brands-section.css';

function PartnerBrandsSection() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        setLoading(true);
        const res = await api.get('/api/products/brands/deal-stats', { params: { limit: 8, partnered: true } });
        setBrands(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error('Partner brands fetch error:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchBrands();
  }, []);

  if (!loading && brands.length === 0) return null;

  return (
    <section className="partner-brands-section">
      <div className="partner-brands-inner">
        <div className="partner-brands-header">
          <h2 className="partner-brands-heading">
            STOCKROOM OFFICIAL PARTNERS
          </h2>
          <Link to="/featured" className="partner-brands-shop-all">
            SHOP NOW →
          </Link>
        </div>

        <div className="partner-brands-row">
          {loading
            ? Array.from({ length: 5 }).map((_, i) => (
                <div key={`skeleton-${i}`} className="brand-card brand-card--skeleton" aria-hidden="true" />
              ))
            : brands.map((brandStat) => (
                <Link
                  key={brandStat.brand}
                  to={`/featured?brand=${encodeURIComponent(brandStat.brand)}`}
                  className="brand-card"
                >
                  <div className="brand-card-media">
                    {brandStat.image ? (
                      <img src={brandStat.image} alt="" className="brand-card-image" loading="lazy" />
                    ) : (
                      <div className="brand-card-image brand-card-image--placeholder" />
                    )}
                  </div>
                  <div className="brand-card-overlay">
                    <h3 className="brand-card-name">{brandStat.brand}</h3>
                    <p className="brand-card-deals">{brandStat.dealCount} deals available</p>
                    <p className="brand-card-discount">Up to {brandStat.maxDiscount}% OFF</p>
                  </div>
                </Link>
              ))}
        </div>
      </div>
    </section>
  );
}

export default PartnerBrandsSection;
